/** Swatches and labels for Sector-Based GHG time-series HTML legend (line + stacked). */
import {
  GHG_BUILDING_ENERGY,
  WASTEWATER_COLOR_HEX,
} from '../theme/navChartPalette';

export type SectorGhgLegendItem = { label: string; color: string };

const BASE_ITEMS: Omit<SectorGhgLegendItem, 'label'>[] = [
  { color: 'rgba(59, 130, 246, 0.85)' },
  { color: 'rgba(96, 165, 250, 0.85)' },
  { color: GHG_BUILDING_ENERGY.naturalGasResidential.bg08 },
  { color: GHG_BUILDING_ENERGY.naturalGasCommercial.bg08 },
  { color: GHG_BUILDING_ENERGY.electricityResidential.bg08 },
  { color: GHG_BUILDING_ENERGY.electricityCommercial.bg08 },
  { color: 'rgba(236, 72, 153, 0.85)' },
];

export function buildTimeSeriesLegendItems(
  seriesLabels: string[],
  wastewaterLabel?: string
): SectorGhgLegendItem[] {
  const labels = [...seriesLabels];
  const items: SectorGhgLegendItem[] = [];
  let baseIdx = 0;
  for (const label of labels) {
    if (label.startsWith('Wastewater')) {
      items.push({ label, color: WASTEWATER_COLOR_HEX });
      continue;
    }
    if (label === 'Offroad') {
      items.push({ label, color: 'rgba(255, 210, 0, 0.85)' });
      continue;
    }
    const swatch = BASE_ITEMS[baseIdx];
    baseIdx += 1;
    items.push({ label, color: swatch?.color ?? '#64748b' });
  }
  if (wastewaterLabel && !labels.some((l) => l.startsWith('Wastewater'))) {
    items.splice(7, 0, { label: wastewaterLabel, color: WASTEWATER_COLOR_HEX });
  }
  return items;
}
